module.exports = __webpack_public_path__ + "everybody_logo_no_border-5869b1c98401b169f224e1e3765b3d50.png";